export default __webpack_public_path__ + "static/new-apob-8f58562def01a6ecad725dfc90eb3baa.jpg";